import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { CtaButton } from './CtaButton';
import { PriceBlock } from './PriceBlock';
export function AgitationSection() {
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2
      }
    }
  };
  const itemVariants = {
    hidden: {
      opacity: 0,
      y: 20
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.6
      }
    }
  };
  return <section className="py-24 px-4 bg-cream" data-id="element-12">
      <div className="max-w-4xl mx-auto text-center" data-id="element-13">
        <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-100px'
      }} data-id="element-14">
          <motion.h2 variants={itemVariants} className="text-3xl md:text-4xl font-bold mb-4" data-id="element-15">
            El problema no es que pienses.
          </motion.h2>

          <motion.h3 variants={itemVariants} className="text-2xl md:text-3xl font-medium text-gold-end mb-12" data-id="element-16">
            El problema es que nadie te enseñó a manejar tu mente.
          </motion.h3>

          <motion.div variants={itemVariants} className="space-y-6 text-lg md:text-xl text-brown-light max-w-2xl mx-auto mb-12" data-id="element-17">
            <p data-id="element-18">La mente moderna está saturada.</p>
            <p data-id="element-19">
              Demasiada información. Demasiadas preocupaciones. Demasiadas cosas
              fuera de control.
            </p>
            <p data-id="element-20">Por eso tantas personas viven con:</p>
          </motion.div>

          <motion.div variants={itemVariants} className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-16" data-id="element-21">
            {['Estrés mental', 'Ansiedad', 'Cansancio psicológico'].map((item, i) => <div key={i} className="bg-cream-alt py-8 px-6 rounded-2xl shadow-sm border border-gold-start/10 flex items-center justify-center" data-id="element-22">
                  <span className="text-xl md:text-2xl font-playfair font-bold text-brown" data-id="element-23">
                    {item}
                  </span>
                </div>)}
          </motion.div>

          <motion.div variants={itemVariants} className="space-y-6 mb-12" data-id="element-24">
            <p className="text-lg md:text-xl text-brown-light" data-id="element-25">
              Pero hay algo importante que debes saber.
            </p>
            <p className="text-2xl md:text-3xl font-playfair font-bold text-brown" data-id="element-26">
              La mente puede entrenarse.
            </p>
          </motion.div>

          <motion.div variants={itemVariants} className="flex flex-col items-center" data-id="element-27">
            <PriceBlock compact data-id="element-28" />
            <CtaButton text="DESCUBRE CÓMO CALMAR TU MENTE" data-id="element-29" />
          </motion.div>
        </motion.div>
      </div>
    </section>;
}